import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import { isBlank } from '@ember/utils';
import { set } from '@ember/object';
import type AttachmentModel from './attachment.ts';
import type AssetSummaryModel from './asset-summary.ts';

interface DownloadUrlsSignature {
  original: string;
}

export default class DigitalAsset extends Model {
  @attr declare bucket: string;
  @attr declare contentType: string;
  @attr declare downloadUrls: DownloadUrlsSignature;
  @attr declare filename: string;
  @attr declare fullPath: string;
  @attr declare raw: Record<string, unknown>;
  @attr declare name: string;
  @attr declare path: string;
  @attr declare size: number;
  @attr declare slug: string;
  @attr declare tags: Record<string, unknown>;
  @attr declare uuid: string;
  @attr declare signedUrl: string;
  @attr declare classification: string;
  @attr declare description: string;

  @attr declare createdAt: string;
  @attr declare updatedAt: string;
  @attr declare attachmentDeletedAt: string | null;

  /*************************
   **  Relationships       **
   *************************/

  @hasMany('attachment', { async: false, inverse: null })
  declare attachments: AttachmentModel[];

  @belongsTo('asset-summary', {
    async: false,
    inverse: 'digitalAsset',
    polymorphic: true,
    as: 'digital-asset',
  })
  declare assetSummary: AssetSummaryModel | null;

  /*************************
   **  Computed Properties **
   *************************/

  get presentableName() {
    const { name, filename } = this;

    return isBlank(name) ? filename : name;
  }

  set presentableName(value) {
    set(this, 'name', value);
  }

  // TODO: convert
  get assetUrl() {
    return this.downloadUrls.original;
  }

  get assetSrcOriginal() {
    return this.downloadUrls.original;
  }
}
